import { domMax } from 'framer-motion';

/**
 * This file exists to supply the `domMax` Framer Motion feature set to the `LazyMotion` component.
 * LazyMotion will load this file after the initial render to reduce the load time of the page.
 * For more info: https://www.framer.com/motion/guide-reduce-bundle-size/#lazy-loading
 */
export default domMax;